import { getDeletedEventsNotification, getEventByID, getEventHistory, getEvents, } from "@/services/api/eventos";
import { useQuery } from "@tanstack/react-query";
import { useWebgate } from "@xvia/webgate-connect";
export const useGetEvents = (categoria) => {
    const { accessToken, initialized } = useWebgate();
    return useQuery({
        queryKey: ["events", categoria],
        queryFn: () => getEvents(accessToken, categoria),
        enabled: !!initialized,
        refetchOnWindowFocus: true,
    });
};
export const useGetEventByID = (id, options) => {
    const { accessToken } = useWebgate();
    return useQuery({
        queryKey: ["eventsByID", id],
        queryFn: () => getEventByID(id, accessToken),
        enabled: options?.enabled && !!accessToken,
        refetchOnWindowFocus: true,
        refetchOnMount: "always",
        staleTime: 0,
    });
};
export const useGetEventsHistory = (id, categoria, subcategoria, dias, page, size) => {
    const { accessToken } = useWebgate();
    return useQuery({
        queryKey: ["eventsHistory", id, categoria, subcategoria, dias, page, size],
        queryFn: () => getEventHistory(id, categoria, subcategoria, dias, page, size, accessToken),
        enabled: !!accessToken,
    });
};
export const useGetDeletedEventsNotification = () => {
    const { accessToken } = useWebgate();
    return useQuery({
        queryKey: ["deletedEventsNotification"],
        queryFn: () => getDeletedEventsNotification(accessToken),
        enabled: !!accessToken,
    });
};
